import React, { useEffect, useState } from 'react';
import { apiFetch } from '../lib/api';

export default function Users() {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({ email: '', first_name: '', last_name: '', role: 'user', pay_type: 'salaried' });
  const [msg, setMsg] = useState('');

  async function load() {
    const res = await apiFetch('/api/users');
    if (res.ok) { const d = await res.json(); setUsers(d.users); }
  }

  async function setPayType(id, pay_type) {
    const res = await apiFetch(`/api/users/${id}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pay_type }),
    });
    if (res.ok) load();
  }

  async function removeUser(u) {
    const name = `${u.first_name} ${u.last_name}`.trim() || u.email;
    if (!window.confirm(`Delete ${name}? This cannot be undone.`)) return;
    setMsg('');
    const res = await apiFetch(`/api/users/${u.id}`, { method: 'DELETE' });
    if (res.ok) { load(); }
    else { const d = await res.json().catch(() => ({})); setMsg(d.error || 'Could not delete user.'); }
  }
  useEffect(() => { load(); }, []);

  async function invite() {
    setMsg('');
    const res = await apiFetch('/api/users', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form),
    });
    if (res.ok) {
      const d = await res.json();
      setMsg(d.invite_sent ? 'Invite sent.' : 'User created (email not sent — check RESEND_API_KEY).');
      setForm({ email: '', first_name: '', last_name: '', role: 'user', pay_type: 'salaried' });
      load();
    } else {
      const d = await res.json().catch(() => ({}));
      setMsg(d.error || 'Could not create user.');
    }
  }

  return (
    <div className="hq-page-content">
      <div className="hq-page-head">
        <h1>Users</h1>
        <p>Invite teammates and manage access.</p>
      </div>

      <div className="hq-panel" style={{ marginBottom: 20 }}>
        <div className="hq-panel-head"><h2>Invite a user</h2></div>
        <div style={{ padding: 20 }}>
          <div className="hq-form">
            <input className="hq-input" placeholder="Email" value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })} />
            <input className="hq-input" placeholder="First name" value={form.first_name}
              onChange={(e) => setForm({ ...form, first_name: e.target.value })} />
            <input className="hq-input" placeholder="Last name" value={form.last_name}
              onChange={(e) => setForm({ ...form, last_name: e.target.value })} />
            <select className="hq-select" value={form.role}
              onChange={(e) => setForm({ ...form, role: e.target.value })}>
              <option value="user">user</option>
              <option value="staff">staff</option>
              <option value="manager">manager</option>
              <option value="admin">admin</option>
            </select>
            <select className="hq-select" value={form.pay_type}
              onChange={(e) => setForm({ ...form, pay_type: e.target.value })}>
              <option value="salaried">salaried</option>
              <option value="hourly">hourly</option>
            </select>
            <button className="hq-btn" onClick={invite}>Invite</button>
          </div>
          {msg && <p className="hq-msg">{msg}</p>}
        </div>
      </div>

      <div className="hq-panel">
        <div className="hq-panel-head"><h2>Team</h2></div>
        <table className="hq-table">
          <thead>
            <tr><th>Name</th><th>Email</th><th>Role</th><th>Pay</th><th>Status</th><th></th></tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id}>
                <td>{`${u.first_name} ${u.last_name}`.trim() || '—'}</td>
                <td>{u.email}</td>
                <td className="hq-role">{u.role}</td>
                <td>
                  <select className="hq-select hq-select-sm" value={u.pay_type || 'salaried'}
                    onChange={(e) => setPayType(u.id, e.target.value)}>
                    <option value="salaried">salaried</option>
                    <option value="hourly">hourly</option>
                  </select>
                </td>
                <td>
                  <span className={u.password_set_at ? 'hq-pill hq-on' : 'hq-pill hq-off'}>
                    {u.password_set_at ? 'Active' : 'Pending invite'}
                  </span>
                </td>
                <td style={{ textAlign: 'right' }}>
                  {u.role !== 'client' && (
                    <button className="hq-link-danger" onClick={() => removeUser(u)}>Delete</button>
                  )}
                </td>
              </tr>
            ))}
            {users.length === 0 && (
              <tr><td className="hq-empty" colSpan={6}>No users yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
